import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  bottomToolbar: {
    backgroundColor: 'white',
  },
}));

export default useStyles;
